import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleSubmit } from "../../controller/SerialFormat/CreateSerialFormatController";
import SerialFormatService from "../../controller/SerialFormat/SerialFormatController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import HelpSite from "../../../Common/HelpLink";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
function CreateSerialFormat() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        ID: "0", vc_SerialFormat: '', bnt_SerialRangeFrom: '', bnt_SerialRangeTo: "",
        vc_SerialPrefix: ''
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);

    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        async function fetchSerialFormat() {
            try {

                const redirectCallback = () => {
                    navigate('/');
                };
                const SerialFormat = await SerialFormatService.GetSerialFormat(redirectCallback);
                setFormData({
                    vc_SerialFormat: SerialFormat[0].vc_Format,
                    bnt_SerialRangeFrom: SerialFormat[0].RangeFrom,
                    bnt_SerialRangeTo: SerialFormat[0].RangeTo,
                    vc_SerialPrefix: SerialFormat[0].Prefix,
                    ID: SerialFormat[0].ID
                });
            } catch (error) {
                console.error('Error fetching company setup:', error);
            }
        }
        fetchSerialFormat();
    }, [navigate]);

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleFormSubmit = async (event) => {
        debugger;
        event.preventDefault();
        const redirectCallback = () => {
            navigate('/');
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        if (formData.ID === "undefined") {
            formData.ID = 0;
        }
        const postData =await handleSubmit(event, formData, setFormData, setErrors, redirectCallback, redirectUserList);
        debugger;
        if (postData.message === "Data added successfully") {
            Swal.fire(
                'Success!',
                'Your record has been saved.',
                'success'
            );
        }
        const updatedSerialFormat = await SerialFormatService.GetSerialFormatByID(redirectCallback, formData.ID);
        debugger;
        setFormData(updatedSerialFormat[0] || {});
        window.scrollTo(0, 0);
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-12" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Financials" Module="26" />
                </div>
            </div>
            <form onSubmit={handleFormSubmit}>

                <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                    <label htmlFor="bnt_SerialRangeFrom" className="col-sm-2 col-form-label">Range From</label>
                    <div className="col-sm-4">
                        <input type="text" className="form-control" name="bnt_SerialRangeFrom" value={formData.bnt_SerialRangeFrom} onChange={handleFieldChange} />
                        {errors.bnt_SerialRangeFrom && <div style={{ color: 'red' }}>{errors.bnt_SerialRangeFrom}</div>}
                    </div>
                    <label htmlFor="bnt_SerialRangeTo" className="col-sm-2 col-form-label">Range To</label>
                    <div className="col-sm-4">
                        <input type="text" className="form-control" name="bnt_SerialRangeTo" value={formData.bnt_SerialRangeTo} onChange={handleFieldChange} />
                        {errors.bnt_SerialRangeTo && <div style={{ color: 'red' }}>{errors.bnt_SerialRangeTo}</div>}
                    </div>
                </div>
                <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                    <label htmlFor="vc_SerialPrefix" className="col-sm-2 col-form-label">Prefix</label>
                    <div className="col-sm-4">
                        <input type="text" className="form-control" name="vc_SerialPrefix" value={formData.vc_SerialPrefix} onChange={handleFieldChange} />
                        {errors.vc_SerialPrefix && <div style={{ color: 'red' }}>{errors.vc_SerialPrefix}</div>}
                    </div>
                    <label htmlFor="vc_SerialFormat" className="col-sm-2 col-form-label">Serial Format</label>
                    <div className="col-sm-4">
                        <input type="text" className="form-control" name="vc_SerialFormat" value={formData.vc_SerialFormat} onChange={handleFieldChange} />
                        {errors.vc_SerialFormat && <div style={{ color: 'red' }}>{errors.vc_SerialFormat}</div>}
                    </div>
                </div>
                <div className="row" style={{ "marginLeft": "0px", "float": "right", "marginRight": "0px" }}>
                    <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary">
                            <i className="icofont-save" aria-hidden="true"> Save

                            </i>
                        </button>

                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateSerialFormat;
